import { render } from "./metricsFacade.vue?vue&type=template&id=4c359ea0"
import script from "./metricsFacade.vue?vue&type=script&lang=js"
export * from "./metricsFacade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__